module.exports = "{{displayName}}<span class=\"caret\" *ngIf=\"sortDirection === 'asc'\" ></span>\r\n<span class=\"caret-inverse\" *ngIf=\"sortDirection === 'desc'\"></span>\r\n<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/sortable-column/sortable-column.component.html
// module id = ./src/app/modules/dashboard/sortable-column/sortable-column.component.html
// module chunks = main